import { getDevice, getDeviceDetail, getGraphic } from "@/api/device";

const state = {
  viewStatus: '',
  loading: true,
};

const getters = {
  viewStatus: state => state.viewStatus,
};

const mutations = {
  VIEW_STATUS(state, value) {
    state.viewStatus = value;
  },

};

const actions = {


}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js